'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentsToSlide = {};
var getId = function getId() {
  return (0, _keys2.default)(componentsToSlide).length;
};

var slideInElement = function slideInElement(id, element, callback) {
  var wasEmpty = (0, _keys2.default)(componentsToSlide) == 0;

  if (element) {
    componentsToSlide[id] = { element: element, callback: callback };
  } else if (id) {
    delete componentsToSlide[id];
  }

  var isEmpty = (0, _keys2.default)(componentsToSlide) == 0;

  if (wasEmpty && !isEmpty) {
    window.addEventListener('scroll', handleWindowScrollForElements);
    window.dispatchEvent(new CustomEvent('scroll'));
  } else if (!wasEmpty && isEmpty) {
    window.removeEventListener('scroll', handleWindowScrollForElements);
  }
};

var handleWindowScrollForElements = _underscore2.default.throttle(function (ev) {
  window.requestAnimationFrame(checkElementsForVisibility);
}, 100);

var checkElementsForVisibility = function checkElementsForVisibility() {
  var windowHeight = window.innerHeight || document.body.clientHeight;

  componentsToSlide = _underscore2.default.mapObject(componentsToSlide, function (c) {
    var _c$element$getBoundin = c.element.getBoundingClientRect(),
        top = _c$element$getBoundin.top;

    if (!c.visible && top < windowHeight) {
      c.callback();
      return (0, _extends3.default)({}, c, { visible: true });
    } else {
      return c;
    }
  });
};

var SlideIn = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SlideIn, _React$Component);

  function SlideIn() {
    (0, _classCallCheck3.default)(this, SlideIn);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SlideIn, [{
    key: 'ref',
    value: function ref(component) {
      if (!this.id) {
        this.id = getId();
      }

      slideInElement(this.id, component, this.onVisible.bind(this));
    }
  }, {
    key: 'onVisible',
    value: function onVisible() {
      var _this2 = this;

      var delay = this.props.delay;


      this.timeout = setTimeout(function () {
        return _this2.setState({
          visible: true
        });
      }, delay);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _c;

      var _props = this.props,
          children = _props.children,
          delay = _props.delay,
          wrapper = _props.wrapper,
          wrapperProps = _props.wrapperProps,
          className = _props.className;
      var visible = this.state.visible;


      var styles = require('./SlideIn.scss');

      var ref = this.ref.bind(this);

      var classes = (0, _classnames2.default)((_c = {}, (0, _defineProperty3.default)(_c, className, true), (0, _defineProperty3.default)(_c, styles['SlideIn'], true), (0, _defineProperty3.default)(_c, styles['SlideIn--visible'], visible), _c));

      return _react2.default.createElement(wrapper, (0, _extends3.default)({}, wrapperProps, { className: classes, ref: ref }), children);
    }
  }]);
  return SlideIn;
}(_react2.default.Component), _class.propTypes = {
  wrapper: _react2.default.PropTypes.string,
  wrapperProps: _react2.default.PropTypes.any,
  className: _react2.default.PropTypes.string,
  delay: _react2.default.PropTypes.number
}, _class.defaultProps = {
  wrapper: 'span',
  delay: 0
}, _temp);
exports.default = SlideIn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideIn/SlideIn.jsx
// module id = 2710
// module chunks = 0